/* eslint-disable complexity */
/*
 * @Author: Dong
 * @Date: 2022-04-11 16:19:06
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-08-26 14:52:26
 */
import React, { useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import { Progress, Button, Spin } from 'sup-ui';
import Icon from 'root/components/Icon';
import classnames from 'classnames';
import { TaskItemType } from './types';
import messages from './messages';
import PopoverDelete from './PopoverDelete';
import { doingIcons, doingStatus, doneStatus, failStatus, strokeColors, successStatus } from './status';

import styles from './index.less';
import useSuccessStatus from './useSuccessStatus';
import LogsDetail from '../LogsDetail';
import moment from 'moment';
interface PropsType extends TaskItemType {
  title: string;
  isSuccess: boolean;
  cancelTask: (name: string, type: string) => void;
  reInstall: (name: string, callback: () => void) => void;
  err: string;
  logs?: any;
  installSupos: boolean;
  operateStatus: (name: string, type: string, callback: (name: string, loading: boolean) => void) => void;
  downloadLogList: (name: string) => void;
  rollBack: (data: any) => void;
  installTime?: string;
  mode?: string;
  catalog: string;
  isRequired: number;
  archiveId: string;
  updateMethod: number;
}

// eslint-disable-next-line complexity
const TaskItem = (props: PropsType) => {
  const intl = useIntl();
  const isSupos = window.location.hash === '#/supos';
  const {
    img,
    name,
    title,
    status,
    type,
    version,
    percent,
    popoverDelete,
    cancelTask,
    reInstall,
    err,
    logs,
    installSupos,
    operateStatus,
    downloadLogList,
    mode,
    catalog,
    isRequired,
    rollBack,
    updateMethod,
    archiveId,
    installTime,
  } = props;

  const successType = useSuccessStatus({ status, type, err, percent }); // 成功提示显隐状态
  const [visibleDetail, setVisibleDetail] = useState(false); // 详情显隐状态
  const [loadingObj, setloadingObj] = useState({ name: '', loading: false }); // 加载中对象

  const newStatus = useMemo(() => {
    return [
      'installing',
      'upgrading',
      'uninstalling',
      'non_disruptive_upgrading',
      'disruptive_upgrading',
      'rolling_back',
    ].includes(status)
      ? 'doing'
      : err
      ? 'failure'
      : successType !== '' || ['running', 'stopped'].includes(status)
      ? 'success'
      : status;
  }, [status, err, successType]);

  // 卸载组件
  const handleUninstall = () => {
    if (!popoverDelete || loadingObj.loading) return;
    popoverDelete(name);
  };

  // 重新安装
  const reInstallTask = () => {
    if (!reInstall) return;
    setloadingObj({ name, loading: true });

    reInstall(name, () => {
      setloadingObj({ name, loading: false });
    });
  };

  // 改变loading状态
  const changeLoading = (name: string, loading: boolean) => {
    setloadingObj({ name, loading });
  };

  const operate = async (name: string, type: string) => {
    setloadingObj({ name, loading: true });
    operateStatus(name, type, changeLoading);
  };

  const typeI18n = type ? intl.formatMessage(messages[type]) : '';

  const statusRender = (newStatus: string) => {
    let mode = '';
    if (updateMethod === 0) mode = intl.formatMessage(messages.undisturbed);
    if (updateMethod === 1) mode = intl.formatMessage(messages.disturbance);
    const undisturbedMode = type === 'upgrade' && (updateMethod === 0 || updateMethod === 1);

    const obj: { [x: string]: React.ReactNode } | null = {
      waiting: (
        <div className={styles.status}>
          <span>{intl.formatMessage(messages.waiting)}...</span>
          {cancelTask && (
            <Icon className={styles.deleteIcon} type="uninstall20" onClick={() => cancelTask(name, type)} />
          )}
        </div>
      ),
      doing: (
        <div className={styles.status}>
          <Icon className={styles.icon} type={doingIcons[type]} />
          {doingStatus[type] && !undisturbedMode && <span>{intl.formatMessage(doingStatus[type])}...</span>}
          {undisturbedMode ? <span>{mode}...</span> : null}
          {catalog === 'middleware' ? <Spin size="small" /> : <span>{percent}%</span>}
        </div>
      ),
      success: (
        <div className={styles.status}>
          {successType !== '' || isSupos ? (
            <>
              <Icon className={styles.icon} type={doneStatus[isSupos ? 'install' : successType]} />
              <span>
                {successStatus[isSupos ? 'install' : successType] &&
                  intl.formatMessage(successStatus[isSupos ? 'install' : successType])}
              </span>
            </>
          ) : (
            <div className={styles.operation}>
              {status === 'stopped' ? (
                <span
                  className={styles.start}
                  onClick={() => {
                    operate(name, '1');
                  }}
                >
                  {intl.formatMessage(messages.start)}
                </span>
              ) : (
                <span
                  className={styles.stop}
                  onClick={() => {
                    operate(name, '2');
                  }}
                >
                  {intl.formatMessage(messages.stop)}
                </span>
              )}

              <PopoverDelete
                className={styles.popover}
                deleteTip={intl.formatMessage(messages.moduleUninstallTip, { name: `${title} ${version}` })}
                deleteCallback={handleUninstall}
                name={name}
                page="systemMange"
                changeLoading={changeLoading}
              />
            </div>
          )}
        </div>
      ),
      failure: (
        <div className={styles.status}>
          {type === 'uninstall' ? (
            <Button size="small" onClick={handleUninstall}>
              {intl.formatMessage(messages.reUnInstall)}
            </Button>
          ) : type !== 'rollBack' ? (
            <Button size="small" onClick={reInstallTask}>
              {intl.formatMessage(type === 'install' ? messages.reInstall : messages.reUpgrading)}
            </Button>
          ) : null}

          {/* 中间件和必需安装的扩展服务不显示取消按钮 */}
          {cancelTask && catalog !== 'middleware' && isRequired !== 1 && ['install', 'rollBack'].includes(type) && (
            <Button size="small" onClick={() => cancelTask(name, type)} style={{ marginLeft: 8 }}>
              {intl.formatMessage(messages.cancel)}
            </Button>
          )}

          {updateMethod === 0 || updateMethod === 1 ? (
            <Button
              size="small"
              style={{ marginLeft: 8 }}
              onClick={() => {
                rollBack({ name, archiveId });
              }}
            >
              {intl.formatMessage(messages.rollBack)}
            </Button>
          ) : null}
        </div>
      ),
      paused: (
        <div>
          {installSupos ? (
            <>
              <Button size="small" onClick={reInstallTask}>
                {intl.formatMessage(messages.continue)}
                {typeI18n}
              </Button>
              <Button size="small" onClick={() => cancelTask(name, type)} style={{ marginLeft: 8 }}>
                {intl.formatMessage(messages.cancel)}
              </Button>
            </>
          ) : (
            <div>
              <span>{intl.formatMessage(messages.itemPaused, { type: typeI18n })}</span>
              <span className={styles.pausedTip}>{intl.formatMessage(messages.pausedTip, { type: typeI18n })}</span>
            </div>
          )}
        </div>
      ),
    };
    return obj[newStatus];
  };

  const toggleVisibleDetail = () => {
    setVisibleDetail(!visibleDetail);
  };

  const classname = useMemo(() => {
    return classnames(styles.container, styles[newStatus], styles[type]);
  }, [newStatus, type]);

  return (
    <Spin spinning={loadingObj.loading}>
      <div className={classname}>
        <div className={newStatus === 'success' ? `${styles.info} ${styles.pointer}` : `${styles.info}`}>
          {catalog === 'middleware' ? (
            <div className={styles.info}>
              <div className={styles.block}>{name}</div>
              <div className={styles.titleBox}>
                <p className={styles.middlewareTitle}>{title}</p>
              </div>
            </div>
          ) : (
            <div className={styles.info}>
              <img className={styles.img} src={img} alt="" />
              <div className={styles.titleBox}>
                <p className={styles.title}>{title}</p>
                <p className={styles.subTitle}>{version}</p>
              </div>
            </div>
          )}

          {['success', 'stopping', 'pending'].includes(newStatus) && !isSupos && (
            <ul className={styles.itemInfo}>
              <li className={styles.statusText}>
                {intl.formatMessage(messages.status)}：
                <span className={styles[status]}>{intl.formatMessage(messages[status])}</span>
              </li>
              <li className={styles.host}>
                {intl.formatMessage(messages.host)}：{mode}
              </li>
              <li className={styles.time}>
                {intl.formatMessage(messages.instalDate)}：
                {installTime ? moment(installTime).format('YYYY[年]MM[月]DD[日] HH:mm') : ''}
              </li>
            </ul>
          )}
          <div className={styles.itemRight}>{statusRender(newStatus)}</div>
        </div>
        {['doing', 'failure'].includes(newStatus) && catalog !== 'middleware' && (
          <Progress
            percent={['success', 'failure'].includes(newStatus) ? 100 : Number(percent)}
            showInfo={false}
            strokeWidth={4}
            strokeColor={type === 'uninstall' && newStatus === 'doing' ? '#646e79' : strokeColors[status]}
          />
        )}
        {newStatus === 'failure' && (
          <>
            <div className={styles.failInfo}>
              <p className={styles.failTxt}>{intl.formatMessage(failStatus[type])}</p>

              <span
                className={styles.downloadLog}
                onClick={() => {
                  downloadLogList(name);
                }}
              >
                {intl.formatMessage(messages.downloadLog)}
              </span>
              <span
                className={classnames(styles.detail, { [`${styles.showDetailList}`]: visibleDetail })}
                onClick={toggleVisibleDetail}
              >
                {intl.formatMessage(messages.detail)}
                <Icon type={visibleDetail ? 'bluearrow16_up' : 'bluearrow16_down'} />
              </span>
            </div>
            {visibleDetail && <LogsDetail err={err} logs={logs} catalog="taskItem" />}
          </>
        )}
      </div>
    </Spin>
  );
};

export default TaskItem;
